import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import { VBToggle } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

Vue.directive('b-toggle', VBToggle)

import store from './store'
import i18n from '@/libs/i18n'
import CamStreamPlugin from './utils/cam/plugin.js'
import router from './router'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

import roles from './const/roles'
/////
import vueDebounce from '@/assets/js/vue-debounce.min.mjs'

import webSocketManager from '@/services/webSocketManager'
// webSocketManager.connect(`ws://${window.location.hostname}:${process.env.VUE_APP_WS_PORT}`)

Vue.use(vueDebounce)


/////


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)


Vue.use(CamStreamPlugin)


// require('@/store/subscriber')
// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')


Vue.config.productionTip = false

Vue.prototype.$roles = roles

Vue.filter('str_limit', function (value, size) {
  if (!value) return '';
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + '...';
});


export const eventBus = new Vue()

store.dispatch('auth/get_me').then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app')

})


